import mobileSortingForm from './mobile-sorting-form';

/**
 * @param {import('../../../../type-definitions').SortingOptions} sortingOptions - sorting options
 * @returns {string} sorting options HTML
 */
export default sortingOptions => `
    <div class="sort-by listing-options-button" tabindex="0">
        <div class="custom-dropdown-container hide-on-mobile">
            <span id="sort-by-label" class="sort-by-label">${window.Resources.SEARCH_SORT}:</span>
            <div id="grid-sort-header-text" class="screen-reader-only-text">
                ${window.Resources.SEARCH_SORT_HIDDEN_LABEL}
            </div>
            <ul class="custom-dropdown">
                <li class="custom-dropdown__label"></li>
                ${
                    sortingOptions.selectedOption
                        ? `
                            <li id="dropdown__selected" aria-haspopup="listbox" aria-labelledby="sort-by-label" tabindex="0"
                                data-sort-id="${sortingOptions.selectedOption.id}" data-value="${sortingOptions.selectedOption.order}">
                                ${sortingOptions.selectedOption.name}
                            </li>
                        `
                        : `
                            <li id="dropdown__selected" aria-haspopup="listbox" aria-labelledby="sort-by-label" tabindex="0">
                                ${window.Resources.SEARCH_UNDEFINED_SORTING_RULE}
                            </li>
                        `
                }
                <li class="custom-dropdown__list-container">
                    <ul class="custom-dropdown__list">
                        <div class="custom-dropdown__border-left"></div>
                        <div class="custom-dropdown__border-right"></div>
                        ${sortingOptions.options
                            .map(
                                sRule => `
                                    <li class="custom-dropdown__list-item" role="listbox" tabindex="0"
                                        data-sort-id="${sRule.id}" data-value="${sRule.order}">
                                        ${sRule.name}
                                    </li>
                                `
                            )
                            .join('')}
                    </ul>
                </li>
            </ul>
        </div>
        ${mobileSortingForm(sortingOptions)}
    </div>
`;
